const SHOW_OVERVIEW_KEY = "showOverview";

export const toShowOverview = () =>
  (localStorage.getItem(SHOW_OVERVIEW_KEY) ?? "true") === "true";

export const saveShowOverviewPreference = (value) => {
  localStorage.setItem(SHOW_OVERVIEW_KEY, value);
};
